import { useEffect, useState } from "react";

/** Tracks the screen's pixel ratio, which changes when the window moves between displays. */
export const useDevicePixelRatio = (): number => {
    const [dpr, setDpr] = useState(() => window.devicePixelRatio);

    useEffect(() => {
        // The query matches only while the ratio holds, so each change resubscribes at the new one.
        const media = window.matchMedia(`(resolution: ${dpr}dppx)`);

        setDpr(window.devicePixelRatio);

        const handleChange = () => setDpr(window.devicePixelRatio);
        media.addEventListener("change", handleChange);

        return () => media.removeEventListener("change", handleChange);
    }, [dpr]);

    return dpr;
};
